import GuidesTabs2 from 'components/layout/GuidesTabs2'
import LoadingScreen from 'components/layout/LoadingScreen'
import LogoRenderer from 'components/layout/LogoRenderer'
import { useUI } from 'ctx/UIContext'
import { Link } from 'react-router-dom'

const PublicGuides = () => {
  const { whiteLabelData } = useUI()

  return (
    <>
      {whiteLabelData.wlabel && whiteLabelData !== undefined ? (
        <>
          {' '}
          <div className='container flex items-center justify-between p-2 mx-auto'>
            <div
              className='h-12 p-2 bg-primary-purple md:h-20'
              style={{
                backgroundColor: whiteLabelData.accent ?? '',
              }}
            >
              <LogoRenderer />
            </div>
            <div>
              <a
                href='/'
                className={`font-semibold py-2 transition-all button hover:opacity-90 ${
                  !whiteLabelData.accent ? ' bg-gray-800 text-white' : ''
                }`}
                style={{
                  color: whiteLabelData.secondary ?? '',
                  backgroundColor: whiteLabelData.primary ?? '',
                }}
              >
                Back to Dashboard
              </a>
            </div>
          </div>
          <div className='relative grid px-4 pt-16 mx-auto md:px-0 md:container place-content-center'>
            <h1 className='mb-2 text-5xl font-bold tracking-tighter text-center md:text-7xl font-title'>
              Get Started
            </h1>
            <p className='relative text-center mb-4 md:mb-8 max-w-lg px-0.5 md:px-0 text-sm md:text-lg leading-5 md:leading-7 text-gray-700'>
              Unlock the full potential of your content with our easy-to-follow
              guides.
            </p>
          </div>
          <div className='container py-4 pb-32 mx-auto'>
            <GuidesTabs2 />
          </div>
        </>
      ) : (
        <LoadingScreen isLoading={true} />
      )}
    </>
  )
}

export default PublicGuides
